import Base from "../base";


export default class GroupsServices extends Base {
    static endpointUrl = "permisos/"
}